import type { InfringementActionLog } from '@/modules/infringements/types.graphl'
import { useIssueActionString, type IssueActionLog } from '..'
import { format } from '@/utils/date-fns'
import { ExportMetadataTooltip } from './export-metadata-tooltip'

type Props = {
  /** Also renders infringement action logs (see `InfringementsTable`). */
  node: IssueActionLog | InfringementActionLog
}

/**
 * Renders the metadata tooltip for an action, if that action type has one.
 * Each action owns its own layout — add a case to support a new one.
 */
const ActionMetadata = ({ node }: Props) => {
  switch (node.action) {
    case 'EXPORTED':
      return <ExportMetadataTooltip node={node} />
    default:
      return null
  }
}

export const ActionLogTableRowAction = (props: Props) => {
  const actionString = useIssueActionString(props.node)

  return (
    <td>
      {actionString}
      <ActionMetadata node={props.node} />
    </td>
  )
}

const ActionLogTableRow = (props: Props) => {
  const { node } = props

  const createdAt = format(new Date(node.createdAt), 'PPpp')

  return (
    <tr key={node.id}>
      <td>{createdAt}</td>
      <ActionLogTableRowAction node={node} />
    </tr>
  )
}

export default ActionLogTableRow
